import { configure } from "mobx"

//关闭必须要传action才能更改数据的模式
configure({
    enforceActions: "never",
})